"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = require("babel-runtime/core-js/object/freeze");

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 解析状态枚举：可以解析、解析失败、解析成功
 * 
 * @class ResolveState
 */
var ResolveState =

/**
 * 创建一个状态枚举
 * 
 * @ignore
 * @param {any} 状态，0~2 
 * @memberof ResolveState
 */


/**
 * 解析失败
 * 
 * @static
 * @memberof ResolveState
 */
function ResolveState(state) {
  (0, _classCallCheck3.default)(this, ResolveState);

  this.state = state;
  (0, _freeze2.default)(this);
}

/**
 * 解析成功
 * 
 * @static
 * @memberof ResolveState
 */


/**
 * 可解析
 * 
 * @static
 * @memberof ResolveState
 */
;

ResolveState.RESOLVABLE = new ResolveState(0);
ResolveState.RESOLVEFAILED = new ResolveState(1);
ResolveState.RESOLVESUCCESS = new ResolveState(2);
exports.default = ResolveState;

(0, _freeze2.default)(ResolveState);
//# sourceMappingURL=ResolveState.js.map